// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pro-rata-report-generator {
  display: contents;
}

.report-button {
  background-color: white;
  border: 1px solid var(--gray-300);
  color: var(--gray-700);
  border-radius: 4px;
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 1rem;
  height: 44px;
  min-height: 44px;
  box-sizing: border-box;
}

.report-button:hover {
  background-color: var(--gray-100);
  border-color: var(--gray-400);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.report-modal-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: relative;
  z-index: 1001;
}

.report-modal-header {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  background-color: #f8f9fa;
}

.report-modal-header h2 {
  margin: 0;
  font-size: 1.4rem;
  color: #6200cc;
}

.modal-close-button {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  font-size: 1.2rem;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* edit supplier individual */
.edit-supplier-report {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 columns */
  gap: 15px;
}

.editable-field {
  display: flex;
  flex-direction: column;
}

.editable-field label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.supplier-input,
.supplier-textarea {
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
}

.supplier-input:focus,
.supplier-textarea:focus {
  border-color: #007bff;
}

/* Full width for address */
.editable-field.full-width {
  grid-column: span 2;
}

.modal-close-button:hover {
  background-color: #f8f9fa;
  color: #495057;
}

.report-selection-container {
  padding: 20px;
  overflow-y: auto;
}


.report-types-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-top: 10px;
}

.report-type-card {
  background-color: #fff;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.report-type-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  border-color: #d9b8ff;
}

.report-type-card h3 {
  margin: 0;
  color: #333;
  font-size: 1.2rem;
  text-align: center;
}

.report-type-card p {
  margin: 0;
  color: #555;
  font-size: 0.9rem;
  text-align: center;
}

.report-icon {
  font-size: 2.5rem;
  color: #6200cc;
  margin-bottom: 10px;
}

.report-date-filter-container {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
  flex: 1 1;
}

.back-button-container {
  margin-bottom: 10px;
}

.back-to-reports-button {
  background: none;
  border: none;
  color: #6200cc;
  cursor: pointer;
  padding: 0;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 5px;
}

.back-to-reports-button:hover {
  text-decoration: underline;
}

.report-info {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid #6200cc;
}

.report-info .report-icon {
  font-size: 2rem;
  margin-bottom: 0;
}

.report-info-text h3 {
  margin: 0 0 5px 0;
  color: #333;
}

.report-info-text p {
  margin: 0;
  color: #555;
  font-size: 0.9rem;
}

.date-inputs-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.date-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.date-input-group label {
  font-weight: 500;
  color: #333;
}

.date-input-wrapper {
  position: relative;
  cursor: pointer;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: #fff;
  transition: all 0.2s ease;
}

.date-input-wrapper:hover {
  border-color: #6200cc;
  background-color: #faf5ff;
}

.date-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  z-index: 1;
}

.date-input {
  width: 100%;
  padding: 10px 10px 10px 35px;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  background: transparent;
  cursor: pointer;
}

.date-input:focus {
  outline: none;
}

.report-error-message {
  padding: 10px;
  background-color: #f8d7da;
  color: #721c24;
  border-radius: 4px;
  margin-top: 10px;
}

.brate-toggle-container {
  margin: 15px 0;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #28a745;
}

.brate-toggle-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 0.95rem;
  color: #333;
  -webkit-user-select: none;
          user-select: none;
}

.brate-toggle-input {
  display: none;
}

.brate-toggle-slider {
  position: relative;
  width: 48px;
  height: 24px;
  background-color: #ccc;
  border-radius: 24px;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.brate-toggle-slider:before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.brate-toggle-input:checked+.brate-toggle-slider {
  background-color: #28a745;
}

.brate-toggle-input:checked+.brate-toggle-slider:before {
  transform: translateX(24px);
}

.brate-toggle-text {
  font-weight: 500;
  line-height: 1.4;
}

.report-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.secondary-button,
.primary-button,
.secondary-button-generate,
.primary-button-generate {
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  font-size: 0.95rem;
  min-width: 120px;
}

.secondary-button,
.secondary-button-generate {
  background-color: #fff;
  color: #6c757d;
  border: 1.5px solid #dee2e6;
}

.secondary-button:hover:not(:disabled),
.secondary-button-generate:hover:not(:disabled) {
  background-color: #f8f9fa;
  border-color: #adb5bd;
  color: #495057;
}

.primary-button,
.primary-button-generate {
  background-color: #6200cc;
  color: white;
  border: none;
  box-shadow: 0 2px 4px rgba(98, 0, 204, 0.2);
}

.primary-button:hover:not(:disabled),
.primary-button-generate:hover:not(:disabled) {
  background-color: #5100a9;
  box-shadow: 0 4px 8px rgba(98, 0, 204, 0.3);
  transform: translateY(-1px);
}

.primary-button:active:not(:disabled),
.primary-button-generate:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(98, 0, 204, 0.2);
}

.secondary-button:disabled,
.primary-button:disabled,
.secondary-button-generate:disabled,
.primary-button-generate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.fa-spin {
  animation: fa-spin 2s infinite linear;
}

@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .report-modal-content {
    width: 95%;
    max-width: 95%;
  }

  .report-modal-header {
    padding: 15px;
  }

  .report-modal-header h2 {
    font-size: 1.1rem;
  }

  .report-types-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .report-type-card {
    padding: 12px;
  }

  .report-type-card h3 {
    font-size: 0.9rem;
  }

  .report-type-card p {
    font-size: 0.75rem;
  }

  .report-icon {
    font-size: 1.8rem;
    margin-bottom: 5px;
  }

  .date-inputs-container {
    grid-template-columns: 1fr;
  }

  .report-date-filter-container {
    padding: 15px;
    gap: 15px;
  }

  .report-info {
    padding: 12px;
    gap: 12px;
  }

  .report-info .report-icon {
    font-size: 1.5rem;
  }

  .report-info-text h3 {
    font-size: 0.95rem;
  }

  .report-info-text p {
    font-size: 0.8rem;
  }

  .date-input-group label {
    font-size: 0.85rem;
  }

  .date-input {
    padding: 10px;
    font-size: 0.9rem;
  }

  .report-actions {
    flex-direction: column !important;
    gap: 10px;
    margin-top: 15px;
    padding-top: 15px;
  }

  .secondary-button,
  .primary-button,
  .secondary-button-generate,
  .primary-button-generate {
    width: 100% !important;
    padding: 12px 20px;
    font-size: 0.9rem;
    min-width: unset;
    flex: 1 1 !important;
  }

  .back-to-reports-button {
    font-size: 0.85rem;
  }

  .brate-toggle-container {
    margin: 10px 0;
    padding: 12px;
  }

  .brate-toggle-label {
    font-size: 0.9rem;
    gap: 10px;
  }

  .brate-toggle-slider {
    width: 44px;
    height: 22px;
  }

  .brate-toggle-slider:before {
    width: 18px;
    height: 18px;
    top: 2px;
    left: 2px;
  }

  .brate-toggle-input:checked+.brate-toggle-slider:before {
    transform: translateX(22px);
  }
}

/* Extra Small Mobile */
@media (max-width: 480px) {
  .report-actions {
    flex-direction: column !important;
    gap: 8px;
    margin-top: 12px;
    padding-top: 12px;
  }

  .secondary-button,
  .primary-button,
  .secondary-button-generate,
  .primary-button-generate {
    width: 100% !important;
    padding: 10px 16px;
    font-size: 0.85rem;
    min-width: unset;
    border-radius: 4px;
    flex: 1 1 !important;
  }

  .report-modal-content {
    width: 98%;
    max-width: 98%;
    margin: 10px;
  }
}

/* Supplier Selection Modal Styles */
.supplier-selection-container {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.suppliers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.supplier-card {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
}

.supplier-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #6200cc 0%, #8b5cf6 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.supplier-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
  border-color: #6200cc;
}

.supplier-card:hover::before {
  opacity: 1;
}

.supplier-info h3 {
  color: #1e293b;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.supplier-info p {
  color: #64748b;
  font-size: 0.9rem;
  margin: 6px 0;
  line-height: 1.4;
}

.supplier-info strong {
  color: #374151;
  font-weight: 600;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #64748b;
}

.loading-container span {
  margin-top: 12px;
  font-size: 0.95rem;
}

/* Supplier Details Modal Styles */
.supplier-details-container {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.supplier-info-section {
  margin-bottom: 24px;
}

.supplier-info-section h3 {
  color: #1e293b;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e2e8f0;
}

.supplier-details p {
  color: #64748b;
  font-size: 0.95rem;
  margin: 8px 0;
  line-height: 1.5;
}

.supplier-details strong {
  color: #374151;
  font-weight: 600;
  min-width: 120px;
  display: inline-block;
}

.supplier-actions-section {
  display: flex;
  gap: 12px;
  margin: 20px 0;
}

.edit-supplier-btn,
.download-supplier-report-btn,
.view-pro-rata-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  flex: 1 1;
  justify-content: center;
}

.edit-supplier-btn {
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}

.edit-supplier-btn:hover {
  background-color: #e5e7eb;
  border-color: #9ca3af;
}

.download-supplier-report-btn {
  background-color: #6200cc;
  color: white;
}

.download-supplier-report-btn:hover {
  background-color: #5a0bb8;
  transform: translateY(-1px);
}

.download-supplier-report-btn:disabled {
  background-color: #a78bfa;
  cursor: not-allowed;
  transform: none;
}

/* Editable Supplier Fields */
.editable-field {
  margin: 12px 0;
}

.editable-field label {
  display: block;
  color: #374151;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 6px;
}

.supplier-input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.supplier-input:focus {
  outline: none;
  border-color: #6200cc;
  box-shadow: 0 0 0 3px rgba(98, 0, 204, 0.1);
}

.supplier-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.9rem;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
  transition: all 0.2s ease;
  box-sizing: border-box;
}

.supplier-textarea:focus {
  outline: none;
  border-color: #6200cc;
  box-shadow: 0 0 0 3px rgba(98, 0, 204, 0.1);
}

.cancel-edit-btn,
.save-supplier-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  flex: 1 1;
  justify-content: center;
}

.cancel-edit-btn {
  background-color: #ef4444;
  color: white;
}

.cancel-edit-btn:hover {
  background-color: #dc2626;
  transform: translateY(-1px);
}

.save-supplier-btn {
  background-color: #10b981;
  color: white;
}

.save-supplier-btn:hover {
  background-color: #059669;
  transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 768px) {
  .suppliers-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 12px;
  }

  .supplier-card {
    padding: 16px;
  }

  .supplier-info h3 {
    font-size: 1rem;
  }

  .supplier-info p {
    font-size: 0.85rem;
  }

  .supplier-actions-section {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .suppliers-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .supplier-card {
    padding: 14px;
  }

  .supplier-selection-container {
    padding: 16px;
  }

  .supplier-details-container {
    padding: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProRataReportGenerator.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;;;EAIE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;;EAEE,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;;;;EAIE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;;IAIE,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,oBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,iCAAiC;IACjC,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;;IAIE,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,cAAc;IACd,YAAY;EACd;AACF;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".pro-rata-report-generator {\n  display: contents;\n}\n\n.report-button {\n  background-color: white;\n  border: 1px solid var(--gray-300);\n  color: var(--gray-700);\n  border-radius: 4px;\n  padding: 0.75rem 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 1rem;\n  height: 44px;\n  min-height: 44px;\n  box-sizing: border-box;\n}\n\n.report-button:hover {\n  background-color: var(--gray-100);\n  border-color: var(--gray-400);\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(2px);\n}\n\n.report-modal-content {\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  width: 90%;\n  max-width: 700px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  position: relative;\n  z-index: 1001;\n}\n\n.report-modal-header {\n  padding: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n}\n\n.report-modal-header h2 {\n  margin: 0;\n  font-size: 1.4rem;\n  color: #6200cc;\n}\n\n.modal-close-button {\n  background: none;\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 4px;\n  font-size: 1.2rem;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* edit supplier individual */\n.edit-supplier-report {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* 2 columns */\n  gap: 15px;\n}\n\n.editable-field {\n  display: flex;\n  flex-direction: column;\n}\n\n.editable-field label {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.supplier-input,\n.supplier-textarea {\n  padding: 8px 10px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n}\n\n.supplier-input:focus,\n.supplier-textarea:focus {\n  border-color: #007bff;\n}\n\n/* Full width for address */\n.editable-field.full-width {\n  grid-column: span 2;\n}\n\n.modal-close-button:hover {\n  background-color: #f8f9fa;\n  color: #495057;\n}\n\n.report-selection-container {\n  padding: 20px;\n  overflow-y: auto;\n}\n\n\n.report-types-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 20px;\n  margin-top: 10px;\n}\n\n.report-type-card {\n  background-color: #fff;\n  border: 1px solid #e8eaed;\n  border-radius: 8px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.report-type-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);\n  border-color: #d9b8ff;\n}\n\n.report-type-card h3 {\n  margin: 0;\n  color: #333;\n  font-size: 1.2rem;\n  text-align: center;\n}\n\n.report-type-card p {\n  margin: 0;\n  color: #555;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.report-icon {\n  font-size: 2.5rem;\n  color: #6200cc;\n  margin-bottom: 10px;\n}\n\n.report-date-filter-container {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.back-button-container {\n  margin-bottom: 10px;\n}\n\n.back-to-reports-button {\n  background: none;\n  border: none;\n  color: #6200cc;\n  cursor: pointer;\n  padding: 0;\n  font-size: 0.9rem;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.back-to-reports-button:hover {\n  text-decoration: underline;\n}\n\n.report-info {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  background-color: #f8f9fa;\n  padding: 15px;\n  border-radius: 8px;\n  border-left: 4px solid #6200cc;\n}\n\n.report-info .report-icon {\n  font-size: 2rem;\n  margin-bottom: 0;\n}\n\n.report-info-text h3 {\n  margin: 0 0 5px 0;\n  color: #333;\n}\n\n.report-info-text p {\n  margin: 0;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.date-inputs-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.date-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.date-input-group label {\n  font-weight: 500;\n  color: #333;\n}\n\n.date-input-wrapper {\n  position: relative;\n  cursor: pointer;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  background-color: #fff;\n  transition: all 0.2s ease;\n}\n\n.date-input-wrapper:hover {\n  border-color: #6200cc;\n  background-color: #faf5ff;\n}\n\n.date-icon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n  z-index: 1;\n}\n\n.date-input {\n  width: 100%;\n  padding: 10px 10px 10px 35px;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  background: transparent;\n  cursor: pointer;\n}\n\n.date-input:focus {\n  outline: none;\n}\n\n.report-error-message {\n  padding: 10px;\n  background-color: #f8d7da;\n  color: #721c24;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.brate-toggle-container {\n  margin: 15px 0;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #28a745;\n}\n\n.brate-toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  color: #333;\n  user-select: none;\n}\n\n.brate-toggle-input {\n  display: none;\n}\n\n.brate-toggle-slider {\n  position: relative;\n  width: 48px;\n  height: 24px;\n  background-color: #ccc;\n  border-radius: 24px;\n  transition: all 0.3s ease;\n  flex-shrink: 0;\n}\n\n.brate-toggle-slider:before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background-color: white;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.brate-toggle-input:checked+.brate-toggle-slider {\n  background-color: #28a745;\n}\n\n.brate-toggle-input:checked+.brate-toggle-slider:before {\n  transform: translateX(24px);\n}\n\n.brate-toggle-text {\n  font-weight: 500;\n  line-height: 1.4;\n}\n\n.report-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #e9ecef;\n}\n\n.secondary-button,\n.primary-button,\n.secondary-button-generate,\n.primary-button-generate {\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  font-size: 0.95rem;\n  min-width: 120px;\n}\n\n.secondary-button,\n.secondary-button-generate {\n  background-color: #fff;\n  color: #6c757d;\n  border: 1.5px solid #dee2e6;\n}\n\n.secondary-button:hover:not(:disabled),\n.secondary-button-generate:hover:not(:disabled) {\n  background-color: #f8f9fa;\n  border-color: #adb5bd;\n  color: #495057;\n}\n\n.primary-button,\n.primary-button-generate {\n  background-color: #6200cc;\n  color: white;\n  border: none;\n  box-shadow: 0 2px 4px rgba(98, 0, 204, 0.2);\n}\n\n.primary-button:hover:not(:disabled),\n.primary-button-generate:hover:not(:disabled) {\n  background-color: #5100a9;\n  box-shadow: 0 4px 8px rgba(98, 0, 204, 0.3);\n  transform: translateY(-1px);\n}\n\n.primary-button:active:not(:disabled),\n.primary-button-generate:active:not(:disabled) {\n  transform: translateY(0);\n  box-shadow: 0 1px 2px rgba(98, 0, 204, 0.2);\n}\n\n.secondary-button:disabled,\n.primary-button:disabled,\n.secondary-button-generate:disabled,\n.primary-button-generate:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.fa-spin {\n  animation: fa-spin 2s infinite linear;\n}\n\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .report-modal-content {\n    width: 95%;\n    max-width: 95%;\n  }\n\n  .report-modal-header {\n    padding: 15px;\n  }\n\n  .report-modal-header h2 {\n    font-size: 1.1rem;\n  }\n\n  .report-types-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n\n  .report-type-card {\n    padding: 12px;\n  }\n\n  .report-type-card h3 {\n    font-size: 0.9rem;\n  }\n\n  .report-type-card p {\n    font-size: 0.75rem;\n  }\n\n  .report-icon {\n    font-size: 1.8rem;\n    margin-bottom: 5px;\n  }\n\n  .date-inputs-container {\n    grid-template-columns: 1fr;\n  }\n\n  .report-date-filter-container {\n    padding: 15px;\n    gap: 15px;\n  }\n\n  .report-info {\n    padding: 12px;\n    gap: 12px;\n  }\n\n  .report-info .report-icon {\n    font-size: 1.5rem;\n  }\n\n  .report-info-text h3 {\n    font-size: 0.95rem;\n  }\n\n  .report-info-text p {\n    font-size: 0.8rem;\n  }\n\n  .date-input-group label {\n    font-size: 0.85rem;\n  }\n\n  .date-input {\n    padding: 10px;\n    font-size: 0.9rem;\n  }\n\n  .report-actions {\n    flex-direction: column !important;\n    gap: 10px;\n    margin-top: 15px;\n    padding-top: 15px;\n  }\n\n  .secondary-button,\n  .primary-button,\n  .secondary-button-generate,\n  .primary-button-generate {\n    width: 100% !important;\n    padding: 12px 20px;\n    font-size: 0.9rem;\n    min-width: unset;\n    flex: 1 !important;\n  }\n\n  .back-to-reports-button {\n    font-size: 0.85rem;\n  }\n\n  .brate-toggle-container {\n    margin: 10px 0;\n    padding: 12px;\n  }\n\n  .brate-toggle-label {\n    font-size: 0.9rem;\n    gap: 10px;\n  }\n\n  .brate-toggle-slider {\n    width: 44px;\n    height: 22px;\n  }\n\n  .brate-toggle-slider:before {\n    width: 18px;\n    height: 18px;\n    top: 2px;\n    left: 2px;\n  }\n\n  .brate-toggle-input:checked+.brate-toggle-slider:before {\n    transform: translateX(22px);\n  }\n}\n\n/* Extra Small Mobile */\n@media (max-width: 480px) {\n  .report-actions {\n    flex-direction: column !important;\n    gap: 8px;\n    margin-top: 12px;\n    padding-top: 12px;\n  }\n\n  .secondary-button,\n  .primary-button,\n  .secondary-button-generate,\n  .primary-button-generate {\n    width: 100% !important;\n    padding: 10px 16px;\n    font-size: 0.85rem;\n    min-width: unset;\n    border-radius: 4px;\n    flex: 1 !important;\n  }\n\n  .report-modal-content {\n    width: 98%;\n    max-width: 98%;\n    margin: 10px;\n  }\n}\n\n/* Supplier Selection Modal Styles */\n.supplier-selection-container {\n  padding: 20px;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.suppliers-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.supplier-card {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  position: relative;\n  overflow: hidden;\n}\n\n.supplier-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #6200cc 0%, #8b5cf6 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.supplier-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);\n  border-color: #6200cc;\n}\n\n.supplier-card:hover::before {\n  opacity: 1;\n}\n\n.supplier-info h3 {\n  color: #1e293b;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n  line-height: 1.3;\n}\n\n.supplier-info p {\n  color: #64748b;\n  font-size: 0.9rem;\n  margin: 6px 0;\n  line-height: 1.4;\n}\n\n.supplier-info strong {\n  color: #374151;\n  font-weight: 600;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  color: #64748b;\n}\n\n.loading-container span {\n  margin-top: 12px;\n  font-size: 0.95rem;\n}\n\n/* Supplier Details Modal Styles */\n.supplier-details-container {\n  padding: 20px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.supplier-info-section {\n  margin-bottom: 24px;\n}\n\n.supplier-info-section h3 {\n  color: #1e293b;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.supplier-details p {\n  color: #64748b;\n  font-size: 0.95rem;\n  margin: 8px 0;\n  line-height: 1.5;\n}\n\n.supplier-details strong {\n  color: #374151;\n  font-weight: 600;\n  min-width: 120px;\n  display: inline-block;\n}\n\n.supplier-actions-section {\n  display: flex;\n  gap: 12px;\n  margin: 20px 0;\n}\n\n.edit-supplier-btn,\n.download-supplier-report-btn,\n.view-pro-rata-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  flex: 1;\n  justify-content: center;\n}\n\n.edit-supplier-btn {\n  background-color: #f3f4f6;\n  color: #374151;\n  border: 1px solid #d1d5db;\n}\n\n.edit-supplier-btn:hover {\n  background-color: #e5e7eb;\n  border-color: #9ca3af;\n}\n\n.download-supplier-report-btn {\n  background-color: #6200cc;\n  color: white;\n}\n\n.download-supplier-report-btn:hover {\n  background-color: #5a0bb8;\n  transform: translateY(-1px);\n}\n\n.download-supplier-report-btn:disabled {\n  background-color: #a78bfa;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Editable Supplier Fields */\n.editable-field {\n  margin: 12px 0;\n}\n\n.editable-field label {\n  display: block;\n  color: #374151;\n  font-weight: 600;\n  font-size: 0.9rem;\n  margin-bottom: 6px;\n}\n\n.supplier-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.supplier-input:focus {\n  outline: none;\n  border-color: #6200cc;\n  box-shadow: 0 0 0 3px rgba(98, 0, 204, 0.1);\n}\n\n.supplier-textarea {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 80px;\n  transition: all 0.2s ease;\n  box-sizing: border-box;\n}\n\n.supplier-textarea:focus {\n  outline: none;\n  border-color: #6200cc;\n  box-shadow: 0 0 0 3px rgba(98, 0, 204, 0.1);\n}\n\n.cancel-edit-btn,\n.save-supplier-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  flex: 1;\n  justify-content: center;\n}\n\n.cancel-edit-btn {\n  background-color: #ef4444;\n  color: white;\n}\n\n.cancel-edit-btn:hover {\n  background-color: #dc2626;\n  transform: translateY(-1px);\n}\n\n.save-supplier-btn {\n  background-color: #10b981;\n  color: white;\n}\n\n.save-supplier-btn:hover {\n  background-color: #059669;\n  transform: translateY(-1px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .suppliers-grid {\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    gap: 12px;\n  }\n\n  .supplier-card {\n    padding: 16px;\n  }\n\n  .supplier-info h3 {\n    font-size: 1rem;\n  }\n\n  .supplier-info p {\n    font-size: 0.85rem;\n  }\n\n  .supplier-actions-section {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 480px) {\n  .suppliers-grid {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .supplier-card {\n    padding: 14px;\n  }\n\n  .supplier-selection-container {\n    padding: 16px;\n  }\n\n  .supplier-details-container {\n    padding: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
